(function () {
    'use strict';

    angular.module('SMART2').service('debouncer', ['$timeout', function ($timeout) {
        var functionTimeout;

        this.add = function (callback, duration) {
            if (functionTimeout) {
                $timeout.cancel(functionTimeout);
            }
            functionTimeout = $timeout(function () {
                angular.isFunction(callback) && callback();
            }, duration ? duration : 1000);
        };

        this.cancel = function () {
            $timeout.cancel(functionTimeout);
            functionTimeout = null;
        };
    }]);
})();